import { Link } from 'react-router-dom';

interface ComicCardProps {
  id: number;
  title: string;
  cover: string;
  rating: number;
  category: string;
  chapters: number;
  status: string;
  views: number;
  tags: string[];
}

export default function ComicCard({ id, title, cover, rating, category, chapters, status, views, tags }: ComicCardProps) {
  const formattedViews = views >= 10000 ? `${(views / 10000).toFixed(1)}万` : views.toString();

  return (
    <Link
      to={`/article/${id}`}
      className="group block bg-background-50 rounded-lg border border-background-200 hover:border-primary-300 transition-all duration-200 overflow-hidden"
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={cover}
          alt={title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
        />
        <div className="absolute top-2 left-2">
          <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${
            status === '连载中'
              ? 'bg-primary-500 text-background-50'
              : 'bg-secondary-500 text-background-50'
          }`}>
            {status}
          </span>
        </div>
        <div className="absolute top-2 right-2 flex items-center gap-1 bg-background-950/70 text-accent-400 px-1.5 py-0.5 rounded-md text-xs font-semibold">
          <i className="ri-star-fill text-[10px]"></i>
          {rating}
        </div>
      </div>
      <div className="p-3">
        <h3 className="font-heading text-sm font-bold text-foreground-900 line-clamp-1 mb-1.5">
          {title}
        </h3>
        <div className="flex items-center justify-between text-xs text-foreground-500 mb-2">
          <span className="bg-secondary-100 text-secondary-700 px-1.5 py-0.5 rounded">{category}</span>
          <span>{chapters}话</span>
        </div>
        <div className="flex items-center gap-2 flex-wrap">
          {tags.slice(0, 2).map((tag) => (
            <span key={tag} className="text-[11px] text-foreground-500 bg-background-100 px-1.5 py-0.5 rounded">
              #{tag}
            </span>
          ))}
          <span className="text-[11px] text-foreground-400 ml-auto flex items-center gap-0.5">
            <i className="ri-eye-line text-[10px]"></i>
            {formattedViews}
          </span>
        </div>
      </div>
    </Link>
  );
}